export default __webpack_public_path__ + "034313e3e8bd11f7e0d389b0327c3d4f.png";